import React, { useState } from "react";
import dateString from "helpers/dateString";
import yearsToNow from "helpers/yearsToNow";

// Components
import ExtraAttention from "components/ExtraAttention";
import SubmitTip from "components/SubmitTip";

import SvgChevronVertical from "assets/svgs/chevron-vertical.svg";

const VictimInfo = ({ 
  victim, 
  contributePanelVisible,
  setContributePanelVisible,
  setSignupOpen,
}) => {
  const {
    ageAtDeath,
    ageAtMissing,
    classification,
    contacts,
    dateOfBirth,
    estimatedDateOfBirth,
    dateFound,
    dateMissing,
    dateOfDeath,
    namusNumber,
    needsExtraAttention,
    necmecNumber,
    personVictim,
  } = victim;

  const [isOpen, setIsOpen] = useState(true);

  return (
    <article className="bg-white border max-w-6xl mx-auto rounded">
      <header className="border-b	flex justify-between p-4">
        <h2 className="highlight">Information</h2>
        <button onClick={() => setIsOpen(!isOpen)}>
          <SvgChevronVertical
            className={isOpen ? "" : "rotate-180 transform"}
            width="18"
          />
        </button>
      </header>
      <div className={`overflow-hidden ${isOpen ? "max-h-full" : "max-h-0"}`}>
        <div className="md:flex md:items-start">
          <ol className="pb-2 px-4 text-sm sm:flex sm:flex-wrap md:w-9/12 lg:text-base lg:w-10/12">
            {dateMissing && (
              <li className="flex py-3 md:justify-start sm:w-2/4 lg:w-1/3">
                <strong className="text-gray-400 flex-shrink-0 font-semibold mr-2 w-1/2 md:w-auto">
                  Date Missing:
                </strong>
                {dateString(dateMissing)}
              </li>
            )}
            {dateFound && (
              <li className="flex py-3 md:justify-start sm:w-2/4 lg:w-1/3">
                <strong className="text-gray-400 flex-shrink-0 font-semibold mr-2 w-1/2 md:w-auto">
                  Date Found:
                </strong>
                {dateString(dateFound)}
              </li>
            )}
            {dateOfDeath && (
              <li className="flex py-3 md:justify-start sm:w-2/4 lg:w-1/3">
                <strong className="text-gray-400 flex-shrink-0 font-semibold mr-2 w-1/2 md:w-auto">
                  Date of Death:
                </strong>
                {dateString(dateOfDeath)}
              </li>
            )}
            {dateOfBirth && (
              <li className="flex py-3 md:justify-start sm:w-2/4 lg:w-1/3">
                <strong className="text-gray-400 flex-shrink-0 font-semibold mr-2 w-1/2 md:w-auto">
                  Birthday:
                </strong>
                {dateString(dateOfBirth)}
              </li>
            )}
            {classification === "Missing" &&
              (dateOfBirth || estimatedDateOfBirth) && (
                <li className="flex py-3 md:justify-start sm:w-2/4 lg:w-1/3">
                  <strong className="text-gray-400 flex-shrink-0 font-semibold mr-2 w-1/2 md:w-auto">
                    Current Age:
                  </strong>
                  {yearsToNow(dateOfBirth || estimatedDateOfBirth)}
                </li>
              )}
            {(ageAtDeath || ageAtMissing) && (
              <li className="flex py-3 md:justify-start sm:w-2/4 lg:w-1/3">
                <strong className="text-gray-400 flex-shrink-0 font-semibold mr-2 w-1/2 md:w-auto">
                  Age at Incident:
                </strong>
                {ageAtDeath && ageAtDeath}
                {ageAtMissing && ageAtMissing}
              </li>
            )}
            {namusNumber && (
              <li className="flex py-3 md:justify-start sm:w-2/4 lg:w-1/3">
                <strong className="text-gray-400 flex-shrink-0 font-semibold mr-2 w-1/2 md:w-auto">
                  NAMUS Number:
                </strong>
                {namusNumber}
              </li>
            )}
            {necmecNumber && (
              <li className="flex py-3 md:justify-start sm:w-2/4 lg:w-1/3">
                <strong className="text-gray-400 flex-shrink-0 font-semibold mr-2 w-1/2 md:w-auto">
                  NECMEC Number:
                </strong>
                {necmecNumber}
              </li>
            )}
            {personVictim && personVictim.race && (
              <li className="flex py-3 md:justify-start sm:w-2/4 lg:w-1/3">
                <strong className="text-gray-400 flex-shrink-0 font-semibold mr-2 w-1/2 md:w-auto">
                  Race:
                </strong>
                {personVictim.race}
              </li>
            )}
            {personVictim && personVictim.gender && (
              <li className="flex py-3 md:justify-start sm:w-2/4 lg:w-1/3">
                <strong className="text-gray-400 flex-shrink-0 font-semibold mr-2 w-1/2 md:w-auto">
                  Gender:
                </strong>
                {personVictim.gender}
              </li>
            )}
            {personVictim && personVictim.height && (
              <li className="flex py-3 md:justify-start sm:w-2/4 lg:w-1/3">
                <strong className="text-gray-400 flex-shrink-0 font-semibold mr-2 w-1/2 md:w-auto">
                  Height:
                </strong>
                {personVictim.height}
              </li>
            )}
            {personVictim && personVictim.weight && (
              <li className="flex py-3 md:justify-start sm:w-2/4 lg:w-1/3">
                <strong className="text-gray-400 flex-shrink-0 font-semibold mr-2 w-1/2 md:w-auto">
                  Weight:
                </strong>
                {personVictim.weight}
              </li>
            )}
            {personVictim && personVictim.hair_color && (
              <li className="flex py-3 md:justify-start sm:w-2/4 lg:w-1/3">
                <strong className="text-gray-400 flex-shrink-0 font-semibold mr-2 w-1/2 md:w-auto">
                  Hair Color:
                </strong>
                {personVictim.hair_color}
              </li>
            )}
          </ol>
          <SubmitTip
            className="pb-4 text-center sm:pt-4"
            submitTips={contacts}
          />
        </div>
        {needsExtraAttention && (
          <ExtraAttention 
            contributePanelVisible={contributePanelVisible} 
            setContributePanelVisible={setContributePanelVisible}
            setSignupOpen={setSignupOpen}
           />
        )}
      </div>
    </article>
  );
};

export default VictimInfo;
